import { FC, useState, useEffect, useRef, useId } from "react";
import s from "./ModalPleaseNote.module.scss";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import { useAppDispatch } from "../../../redux/store";
import { changeShowModal } from "../../../redux/reducers/app/appReducer";

type ModalPleaseNoteT = {
  closeFunc: any;
};
export const ModalPleaseNote: FC<ModalPleaseNoteT> = ({ ...props }) => {
  const { closeFunc } = props;
  const wrapperRef: any = useRef(null);
  const [show, setShow] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleClickOutside =
      (wrapperRef: any, closeFunc: any) => (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeFunc();
        }
      };
    document.addEventListener(
      "mousedown",
      handleClickOutside(wrapperRef, closeFunc)
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside(wrapperRef, closeFunc)
      );
    };
  }, [wrapperRef]);

  async function onSubmitForm() {
    // popUp({ type: "success", message: "Email sent successfully." });
    if (show) {
      sessionStorage.setItem("dontShowNote", `${show}`);
    }
    closeFunc();
    dispatch(changeShowModal({ nameModal: "renderLoader", stateModal: true }));
  }

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <div className={s.head}>
        <div className={s.title}>Please note</div>
        <div className={s.close} onClick={closeFunc}>
          <CloseIcon />
        </div>
      </div>
      <div className={s.titleWrapper}>
        <div className={s.modalBody}>

          <div className={s.subtitle}>
            <span>The image will be rendered from the angle that was previously set/selected. Continue rendering?</span>
          </div>
          <div
            className={`${s.checker} ${show && s.active}`}
            onClick={() => setShow(!show)}
          >
            <div className={s.checkbox}></div>
            <span>Do not show again</span>
          </div>
        </div>
      </div>
     

      <footer>
        <div className={s.nav}>
          <div className={s.cancel} onClick={closeFunc}>
            Cancel
          </div>
          <div className={`${s.accept}`} onClick={() => onSubmitForm()}>
            Continue
          </div>
        </div>
      </footer>
    </div>
  );
};
